import { render, staticRenderFns } from "./MainNavbar.vue?vue&type=template&id=4f42340f&scoped=true&"
import script from "./MainNavbar.vue?vue&type=script&lang=js&"
export * from "./MainNavbar.vue?vue&type=script&lang=js&"
import style0 from "./MainNavbar.scss?vue&type=style&index=0&id=4f42340f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f42340f",
  null
  
)

export default component.exports